import { render, staticRenderFns } from "./basicUsersDetail.vue?vue&type=template&id=d132d792&"
import script from "./basicUsersDetail.vue?vue&type=script&lang=js&"
export * from "./basicUsersDetail.vue?vue&type=script&lang=js&"
import style0 from "./basicUsersDetail.vue?vue&type=style&index=0&id=d132d792&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports